/** Cheap mean-luma estimate (samples every 8th pixel, green channel ≈ luma). */
export function meanLuma(img: ImageData): number {
  const { data } = img;
  let sum = 0;
  let n = 0;
  for (let i = 1; i < data.length; i += 32) {
    sum += data[i];
    n++;
  }
  return n > 0 ? sum / n : 0;
}
